import momentJalali from 'moment-jalaali';
import {toEnglishNumber} from '../../../core/utils/number.utils';
import {convertDateToCivil, convertDateToIslamic, convertDateToPersianSimple} from '../../../core/utils/DateUtils';
import momentHijri from 'moment-hijri';
import momentEnglish from 'moment';

export function calculateConvertDate(
  activeStartDateSort: number,
  activeEndDateSort: number,
  startDateValue: string
): string {
  switch (activeStartDateSort) {
    case 0:
      let mj = momentJalali(toEnglishNumber(startDateValue), 'jYYYY/jMM/jDD');
      switch (activeEndDateSort) {
        case 0:
          return startDateValue;
        case 1:
          return convertDateToIslamic(mj.toDate());
        case 2:
          return convertDateToCivil(mj.toDate());
        default:
          return startDateValue;
      }
    case 1:
      let mh = momentHijri(toEnglishNumber(startDateValue), 'iYYYY/iMM/iDD');
      switch (activeEndDateSort) {
        case 0:
          return convertDateToPersianSimple(mh.toDate());
        case 1:
          return startDateValue;
        case 2:
          return convertDateToCivil(mh.toDate());
        default:
          return startDateValue;
      }
    case 2:
      let me = momentEnglish(toEnglishNumber(startDateValue), 'YYYY/MM/DD');
      switch (activeEndDateSort) {
        case 0:
          return convertDateToPersianSimple(me.toDate());
        case 1:
          return convertDateToIslamic(me.toDate());
        case 2:
          return startDateValue;
        default:
          return startDateValue;
      }
    default:
      return startDateValue;
  }
}
